import React from "react";
import { Provider } from "react-redux";
import { createReduxStore } from "../TotalContractRevenue/redux/store";
import ErrorBoundary from "../../../../components/errorBoundary/errorBoundary";
import TotalContractRevenueModule from "./TotalContractRevenueModule";

const TotalContractRevenue = (props) => {
  let {
    organizationId,
    locationId,
    objectId,
    regionId,
    params: { calendarStartDate, calendarEndDate, theBeginningOfTime },
    notifications
  } = props;

  let params = {
    organizationId,
    locationId,
    objectId,
    regionId,
    calendarEndDate,
    calendarStartDate,
    theBeginningOfTime
  };
  return (
    <Provider store={createReduxStore()}>
      <ErrorBoundary moduleName="TotalContractRevenue" {...notifications}>
        <TotalContractRevenueModule params={params} />
      </ErrorBoundary>
    </Provider>
  );
};

export default TotalContractRevenue;
